import React from 'react';
import classNames from 'classnames';
import cls from './TableRowRegistry.module.css';
import { useTableRowRegistry } from './useTableRowRegistry';

interface TableRowRegistryProps {
    classes?: string;
    date: string | null;
    estimateTitle: string | null;
    sum: number;
    currencyCode: string;
    comment: null | string;
    isFooter?: boolean;
}

export const TableRowRegistry = ({
    classes,
    date,
    estimateTitle,
    sum,
    currencyCode,
    comment,
    isFooter,
}: TableRowRegistryProps) => {
    const {} = useTableRowRegistry();
    return (
        <div
            className={classNames(cls.TableRowRegistry, [classes], {
                [cls.TableFooter]: isFooter,
            })}
        >
            <div className={classNames(cls.TableColumn, cls.TableData)}>{date}</div>
            <div className={classNames(cls.TableColumn, cls.TableEstimate)}>
                {estimateTitle ? estimateTitle : i18next.t('TableRowRegistry.return.result')}
            </div>
            <div className={classNames(cls.TableColumn, cls.TableSum)}>{sum}</div>
            <div className={classNames(cls.TableColumn, cls.TableCurrency)}>{currencyCode}</div>
            <div className={classNames(cls.TableColumn, cls.TableComment)}>{comment}</div>
        </div>
    );
};
